import get from 'lodash/get';

const selectShowModal = (state) => get(state, 'settings.showModal', false);
export default selectShowModal;

export const selectUserEmail = (state) => get(state, 'settings.userData.email', '');
